<template>
  <div id="screen" class="ui basic container segment" style="overflow:auto">
    <div class="ui purple segment">
      <h3 style="text-align: center">Search for a vehicle</h3>
      <div class="ui left aligned basic segment">
        <form id="locationform" class="ui form">
          <div class="field">
            <label>Registration:</label>
            <input v-model="reg" @change="regChanged" @keyup="regChanged">
          </div>
        </form>
      </div>
    </div>
    <div class="ui purple segment">
      <div class="ui header">Search results ({{ results.length }} items):</div>

      <div id="resultssegment" style="margin-top:1em">
        <div class="ui">
          <div class="ui fluid buttons">
            <button class="ui small icon button prevbtn" style="max-width:3em" @click="prevClicked"><i class="left chevron icon"></i></button>
            <div class="ui small disabled icon button resulttxt">{{ 'No results' }}</div>
            <button class="ui small icon button nextbtn" style="max-width:3em" @click="nextClicked"><i class="right chevron icon"></i></button>
          </div>
        </div>
        <br>
        <div class="ui">
          <div class="ui stackable four link cards" id="vehiclelist">
            <router-link v-for="(v, index) in results" :key="index" class="vehicle card" :to="{name:'offlineinspection', params:{reg:v.registration}}">
              <div class="content">
                <div class="meta"><b>{{ v.make }} {{ v.model }} {{ v.derivative }}</b></div>
                <div class="meta">{{ v.colour }}</div>
              </div>
              <div class="extra content">
                <div>
                  <span class="right floated meta">{{ v.enginesize }}</span>
                  <span class="meta">{{ v.fueltype }}</span>
                  <div style="clear:both"></div>
                </div>
                <div>
                  <span class="right floated meta">{{ v.finalmileage }} miles</span>
                  <span class="meta">{{ (v.enginetype === 1?'Manual':'Automatic') }}</span>
                </div>
              </div>
              <div class="extra content">
                <span class="right floated">
                  <router-link :to="{name:'history', params:{reg:v.registration}}" class="ui tiny icon button">history</router-link>
                </span>
                <span>
                  <span class="ui yellow label" style="color:black!important">{{ v.registration }}</span>
                </span>
              </div>
            </router-link>
          </div>
        </div>
        <div class="ui">
          <div class="ui fluid buttons">
            <button class="ui small icon button prevbtn" style="max-width:3em" @click="prevClicked"><i class="left chevron icon"></i></button>
            <div class="ui small disabled icon button resulttxt">No results</div>
            <button class="ui small icon button nextbtn" style="max-width:3em" @click="nextClicked"><i class="right chevron icon"></i></button>
          </div>
        </div>
      </div>

    </div>
  </div>
  
</template>

<style>
  /* The Modal (background) */
  #modalcontainer {
    display: none; /* Hidden by default */
    position: fixed; /* Stay in place */
    z-index: 1; /* Sit on top */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    overflow: auto; /* Enable scroll if needed */
    background-color: rgb(0,0,0); /* Fallback color */
    background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
  }

</style>

<script>
//  import { computed } from 'vue';

  // function diff (num1, num2) {
  //   if (num1 > num2) {
  //     return num1 - num2
  //   } else {
  //     return num2 - num1
  //   }
  // }
  
  export default {
    data() {
      return {
        reg:'',
        results:[],
        to:null
      }
    },
    methods: {
      regChanged() {
        console.log(this.reg);
        if (this.to) {
          clearTimeout(this.to);
        }
        this.to = setTimeout(()=>{this.loadSearch()},1000);
      },
      loadSearch() {
        var thiz = this;

        var dts = {
          registration: this.reg
        };

        fetch(this.$host+'/searchvehicle', {
          method: 'POST',
          headers: {'Content-type':'application/json'},
          credentials:'include',
          mode:'cors',
          body: JSON.stringify(dts)
        }).then(res=>res.json()).then(res=>{
          thiz.saving = false;
          if (res.error) {
            //errorBox('Application error #426', res.error);
            console.log('application error #140', res);
          }
          else {
            thiz.results = res.vehicles;
          }
        }).catch(err=>{

          console.log('system error #146', err);
        });
      }
    },
    mounted() {
      setTimeout(()=>{
        const e = document.querySelector('#purpleheader').animate({height:"130px"}, 500)
        e.onfinish = ()=>{
          document.querySelector('#purpleheader').style.height = "130px";
        };
      },0);
    }
  }
</script>
